export interface ExperimentDef<
  Name extends string,
  Variants extends readonly [string, ...string[]]
> {
  name: Name;
  variants: Variants;
}

export type AnyExperimentDef = ExperimentDef<
  string,
  readonly [string, ...string[]]
>;

export type ExperimentVariants<Def extends AnyExperimentDef> =
  Def["variants"][number];

export function experimentDef<
  Name extends string,
  Variants extends readonly [string, ...string[]]
>(name: Name, ...variants: Variants): ExperimentDef<Name, Variants> {
  return { name, variants };
}
